import { Injectable } from '@angular/core';
import { Router, CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { from, Observable } from 'rxjs';
import { map} from 'rxjs/operators';
import { UserService } from './user.service';
import { AccountService } from './account.service';

@Injectable()
export class UnauthorisedAuthGuard implements CanActivate, CanActivateChild {

    constructor(private accountService: AccountService, private _router: Router, private userService: UserService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        return this.checkIsUnauthorised();
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        return this.checkIsUnauthorised();
    }

    private checkIsUnauthorised(): boolean | Observable<boolean> {
        const user = this.accountService.getCurrentUser();
        if (user) {
            let prom = this.userService.navigateToHomePage(user);
            return from(prom)
                .pipe(
                    map(() => false)
                );
        }
        return true;
    }
}
